import { useEffect, useRef, useState } from "react";

function MultiEventsDiagram({
  panelSize,
  groundSize,
  events,
  selectedEvent,
  onSelectEvent,
}) {
  const canvas = useRef();
  const ref = useRef(null);
  const [xmargin, setXmargin] = useState(10);
  const [ymargin, setYmargin] = useState(20);
  const [groundWidth, setGroundWidth] = useState(groundSize.width);
  const [groundHeight, setGroundHeight] = useState(groundSize.height);
  const [scale, setScale] = useState(1);
  const intervalRef = useRef(null);
  const [eventRects, setEventRects] = useState([]);
  const colours = [
    {code:"GOAL", colour:"rgba(255, 255, 0, 0.6)"},
    {code:"BEHI", colour:"rgba(0, 0, 255, 0.6)"},
    {code:"FREE_KICK", colour:"rgba(0, 255, 0, 0.6)"},
    {code:"MARK", colour:"rgba(255, 0, 0, 0.6)"},
  ]

  const getFillColour = (code) => {
    const found = colours.find((c) => c.code === code);
    return found ? found.colour : "rgba(0, 255, 255, 0.6)";
  };

  const draw = () => {
    const ctx = canvas.current.getContext("2d");
    const sc = drawGround(ctx);
    var rcs = [];
    const rad = 6;
    for (var e of events) {
        const xx = -parseFloat(e["chainy"]) * sc;
        const yy = -parseFloat(e["chainx"]) * sc;
        let x = panelSize.width / 2 + xx;
        let y = panelSize.height / 2 + yy;
        ctx.fillStyle = getFillColour(e["STATISTIC_CODE"]);
        ctx.beginPath();
        ctx.arc(x, y, rad, 0, Math.PI * 2);
        ctx.fill();
        if (selectedEvent === e) {
            ctx.strokeStyle = "red";
            ctx.lineWidth = 2;
            ctx.stroke();
        }
        rcs.push({ x: x - rad, y: y - rad, width: rad * 2, height: rad * 2, event: e });
    }
    setEventRects(rcs);
  };

  const drawGround = (ctx) => {
    const { width, height } = panelSize;

    // Set the canvas size
    canvas.current.width = width;
    canvas.current.height = height;

    const ww = width - 2 * xmargin;
    const sc = ww / groundSize.width;
    setScale(sc);
    const hh = groundSize.height * sc;
    setGroundWidth(ww);
    setGroundHeight(hh);
    const topy = (height - hh) / 2;
    setYmargin(topy);
    const bottomy = hh + topy;
    const m50 = 50 * sc;
    const m25 = 25 * sc;
    const m10 = 10 * sc;
    const m9 = 9 * sc;
    const m3 = 3 * sc;
    // Draw the ground
    ctx.fillStyle = "darkgreen";
    ctx.fillRect(0, 0, width, height);
    ctx.fillStyle = "green";
    ctx.beginPath();
    ctx.ellipse(width / 2, height / 2, ww / 2, hh / 2, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.strokeStyle = "white";
    ctx.lineWidth = 2;
    ctx.stroke();
    ctx.save();
    ctx.clip();
    ctx.closePath();

    ctx.beginPath();
    ctx.ellipse(width / 2, topy, m50, m50, 0, 0, Math.PI * 2);
    ctx.stroke();
    ctx.closePath();

    ctx.beginPath();
    ctx.ellipse(width / 2, bottomy, m50, m50, 0, 0, Math.PI * 2);
    ctx.stroke();
    ctx.closePath();

    ctx.strokeRect(width / 2 - m25, height / 2 - m25, m50, m50);
    ctx.strokeRect(width / 2 - m9 / 2, topy, m9, m9);
    ctx.strokeRect(width / 2 - m9 / 2, bottomy - m9, m9, m9);
    ctx.beginPath();
    ctx.arc(width / 2, height / 2, m3 / 2, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(width / 2, height / 2, m10 / 2, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(width / 2 - m10 / 2, height / 2);
    ctx.lineTo(width / 2 + m10 / 2, height / 2);
    ctx.stroke();
    ctx.restore();

    return sc;
  };


  useEffect(() => {
    draw();
  }, [panelSize, groundSize]);


const mousedown = (e) => {
    const rect = canvas.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Check if the click is inside any of the event rectangles
    const clickedEvent = eventRects.find((r) => {
      return (
        x >= r.x &&
        x <= r.x + r.width &&
        y >= r.y &&
        y <= r.y + r.height
      );
    });

    if (clickedEvent) {
      // If an event was clicked, do something with it
      onSelectEvent(clickedEvent.event);
      console.log("Clicked event:", clickedEvent.event);
    }
  };

  return (
    <div className="MultiEventsDiagram" ref={ref}>
      <canvas
        ref={canvas}
        onMouseDown={mousedown}
        // onMouseMove={mousemove}
        // onMouseUp={mouseup}
        // onTouchStart={touchstart}
        // onTouchMove={touchmove}
        // onTouchEnd={touchend}
        width={panelSize?.width}
        height={panelSize?.height}
        // style={{ border: "1px solid #ff0000" }}
      ></canvas>
    </div>
  );
}

export default MultiEventsDiagram;
